import Type from '@/store/mutation-type';
import Vue from 'vue';
import { isArray, isEmpty } from '@/utils/is';

import { getDeviceTypeInfo } from '@/api/devices.js';

let deviceTypeInfoLoading = false;

export default {
  namespaced: 'device',
  state: {
    /**
     * 设备监控页面菜单选中
     * @type {id: string, nodeType: 1|2}
     * @description nodeType 1:机构 2:设备
     */
    monitorMenuActive: {},
    monitorMode: 'list',
    modeList: [
      { key: 'home', componentName: 'deviceHome', text: '首页' },
      { key: 'map', componentName: 'deviceMap', text: '地图' },
      { key: 'list', componentName: 'deviceList', text: '列表' },
      { key: 'scene', componentName: 'deviceScene', text: '场景' },
      { key: 'alarm', componentName: 'deviceAlarm', text: '报警' }
    ],
    monitorConfig: {
      deviceTreeLineNum: 6,
      fontSize: 40,
      mapType: 'B_NORMAL_MAP',
      multiColumn: false,
      fixedHeader: false,
      enableAlarmDisposition: false,
      groupBy: 'deviceType'
    },
    /**
     * 设备类型信息
     */
    deviceTypeInfo: {} // 设备类型信息
  },
  getters: {
    modeMap(state) {
      return state.modeList.reduce((map, e) => {
        map[e.key] = e;
        return map;
      }, {});
    }
  },
  mutations: {
    /**
     * 任务列表当前选择的设备id或最近点击的机构id，用于场景地图
     * @param {State} state
     * @param {{id: deviceId, nodeType: 1|2}} data
     */
    [Type.SET_MONITOR_MENU_ACTIVE](state, data) {
      const { id, nodeType } = data;
      state.monitorMenuActive = { id, nodeType };
    },
    /**
     * 设置任务列表默认选中菜单, 空值时有效
     * @param {any} state
     * @param {{id: deviceId, nodeType: 1|2}} data
     * @returns
     */
    [Type.SET_MONITOR_MENU_DEFAULT_ACTIVE](state, data) {
      if (!isEmpty(state.monitorMenuActive.id)) return;
      const { id, nodeType } = data;
      state.monitorMenuActive = { id, nodeType };
    },
    /**
     * 设置设备监控显示模式
     * @param {State} state
     * @param {'map'|'scene'|'list'} mode
     */
    [Type.SET_MONITOR_MODE](state, mode) {
      state.monitorMode = mode;
    },
    [Type.SET_MONITOR_CONFIG](state, config) {
      if (isEmpty(config)) return;

      const keys = Object.keys(config);
      keys.forEach(key => {
        if (isEmpty(config[key])) return;

        state.monitorConfig[key] = config[key];
      });
    }
  },
  actions: {
    /** 初始化设备类型信息 */
    initDeviceTypeInfo({ state, dispatch }) {
      if (!isEmpty(state.deviceTypeInfo)) return;
      dispatch('refreshDeviceTypeInfo');
    },
    /** 刷新设备类型信息 */
    async refreshDeviceTypeInfo({ state }) {
      if (deviceTypeInfoLoading) return;
      deviceTypeInfoLoading = true;
      try {
        const res = await getDeviceTypeInfo();
        if (isArray(res.data)) {
          res.data.reduce((map, e) => {
            Vue.set(map, e.code, e);
            return map;
          }, state.deviceTypeInfo);
        }
        deviceTypeInfoLoading = false;
        return res;
      } catch (error) {
        console.error(error);
      }

      return null;
    }
  }
};
